import { useState } from 'react';
import { useStore } from 'base/store';
import { isApp, nativeLogin } from 'base/utils/app'

export type ILoginInstance = {
    checkAuth: (callback: () => void) => void;
    loginModalProps: {
        open: boolean;
        onCancel: () => void;
        onLoginSuccess?: () => void;
    };
}

export default function useLogin(): ILoginInstance {
    const [visible, setVisible] = useState<boolean>(false);
    const { userStore } = useStore();

    const checkAuth = (loginCallback: () => void) => {
        if (userStore.checkAuth()) {
            loginCallback();
        } else if (isApp()) {
            nativeLogin(loginCallback);
        } else {
            setVisible(true)
        }
    };

    return {
        checkAuth,
        loginModalProps: {
            open: visible,
            onCancel: () => setVisible(false),
        }
    }
}
